import dynamic from 'next/dynamic';

import { useDucatClient } from '@/context/DucatClientCtx';

import WalletConnectButton from './WalletConnectButton';

const ConnectedWalletMenu = dynamic(() => import('./ConnectedWalletMenu'));

function WalletConnect() {
  const { wallet } = useDucatClient();
  return wallet ? <ConnectedWalletMenu /> : <WalletConnectButton mobileStylesOn />;
}

export default WalletConnect;
